import { AuditConsolePage } from "../../operator/console/audit-console";

export default function ConsoleAuditRoute() {
  return <AuditConsolePage />;
}
